import { NgModule } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  RouterModule,
  Routes,
  withComponentInputBinding,
  withHashLocation,
  withPreloading,
} from '@angular/router';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./layouts/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'forgot-password',
    redirectTo: 'auth',
  },
  {
    path: 'tabs',
    loadChildren: () => import('./layouts/tabs/tabs.module').then((m) => m.TabsPageModule),
  },
  {
    path: '',
    redirectTo: 'tabs',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withComponentInputBinding(),
      withHashLocation()
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
